export default function UserAvatar({
  name,
  avatar,
  size = 40,
  className = "",
  alt = "Profile",
  onClick
}) {
  const firstLetter = String(name || "U").trim().charAt(0).toUpperCase() || "U";
  const style = { width: `${size}px`, height: `${size}px` };

  if (avatar) {
    return (
      <img
        src={avatar}
        alt={alt}
        className={`user-avatar ${className}`.trim()}
        style={style}
        onClick={onClick}
      />
    );
  }

  return (
    <div
      className={`user-avatar user-avatar-fallback ${className}`.trim()}
      style={style}
      onClick={onClick}
      aria-label={alt}
      role="img"
    >
      {firstLetter}
    </div>
  );
}
